import React from "react";
import { Box, Text, Button, Grid, Flex, Modal, Image } from "atoms";

import SuccessGif from "assets/img/success.gif";
import MemoClose from "assets/icons/Close";

export const InvitationSentModal = ({ onClose }) => {
  return (
    <Modal isOpen onClose={onClose}>
      <Box width={{ md: "48.8rem" }}>
        <Box p={{ xs: "2.4rem", lg: "3.2rem" }}>
          <Flex
            justifyContent="space-between"
            borderBottom="0.1rem solid"
            borderColor="neutral.100"
            pb="2.4rem"
          >
            <Text fontSize="2rem" color="primary.900" fontFamily="primaryBold">
              Invite Sent
            </Text>
            <Box color="neutral.900" onClick={onClose} cursor="pointer" textAlign="right">
              <MemoClose height="1.6rem" width="1.6rem" />
            </Box>
          </Flex>
          <Grid justifyContent="center" gridRowGap="2.4rem" mt="2.4rem">
            <Box height="12rem" mx="auto" p="1.5rem">
              <Image
                src={SuccessGif}
                alt="success"
                height="9rem"
                width="9rem"
                objectfit="contain"
              />
            </Box>
            <Text
              fontSize="1.6rem"
              color="primary.900"
              fontFamily="primaryRegular"
              textAlign="center"
            >
              Role Invite Sent to{" "}
              <Text as="span" fontFamily="primaryBold">
                {" "}
                xyz@gmail.com
              </Text>
            </Text>
          </Grid>

          <Button variant="secondary" height={{ xs: "4.3rem", lg: "4.8rem" }} mt="2.4rem">
            Close
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
